<template>
  <div class="list">
    <div class="customText" @click.stop="toggle">
      <span class="feedbackText">{{ $t("layout.navigation04") }}</span>
      <i :class="`fas fa-chevron-${chevron_feedback}`" />
    </div>
    <height_expand>
      <div v-if="expand" class="feedbackList">
        <div
          v-for="(elem, index) in config"
          :key="index"
          :class="{ disable: !submissions_arr[index] }"
          class="feedbackListElem"
          @click.stop="handleClick(index)"
        >
          <span class="type">{{ $t(elem.i18n) }}</span>
          <span class="count">({{ submissions_arr[index] }})</span>
        </div>
      </div>
    </height_expand>
    <div class="sidePadWrapper">
      <div v-if="is_agency" class="borderedWrapper">
        <div class="fakeBorder" />
        <band_select class="skipList" @close="$emit('close')" />
        <div class="fakeBorder" />
      </div>
    </div>
    <div v-if="is_agency" class="title">
      {{ $t("band.RPMenu.account") }}
    </div>
    <nuxt-link
      class="text"
      to="/agency/favorites/"
      @click.native="$emit('close')"
    >
      {{ $t("layout.menu.menu00") }}
    </nuxt-link>
    <nuxt-link
      class="customText"
      to="/band/shop/"
      @click.native="$emit('close')"
    >
      <span class="feedbackText">{{ $t("layout.navigation08") }}</span>
      <div class="quickFlex">
        <span class="amount">{{ grooviz }}</span>
        <img class="grooviesIcon" src="/media/grooviz_light_grey.svg" />
      </div>
    </nuxt-link>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex"

import height_expand from "~/components/transitions/heightExpand"
import band_select from "~/components/nav/loggedIn/contextMenu/band/bandSelect"

import dash_menu_mixin from "~/mixins/nav/dashMenu"

export default {
  components: { height_expand, band_select },
  mixins: [dash_menu_mixin],
  data: function () {
    return { expand: false }
  },
  computed: {
    chevron_feedback: function () {
      return this.expand ? "up" : "down"
    },
    ...mapState({
      grooviz: (state) => state.user.grooviz,
    }),
    ...mapGetters({
      is_agency: "user/IS_AGENCY",
    }),
  },
  methods: {
    toggle: function () {
      this.expand = !this.expand
    },
    close: function () {
      this.$emit("close")
    },
  },
}
</script>

<style scoped src="./band.css"></style>
<style scoped src="./shared.css"></style>
